import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Switch, Route } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import SurveyConfigurator from "../../../../../components/surveyMonkeyConfiguration/surveyConfigurator";
import SurveyDetail from "../../../../../components/surveyMonkeyConfiguration/surveyDetail";
import SurveyResponseAdmin from "../../../../../components/survey/SurveyResponsesAdmin";
export const getSurveyAdminBasePath = () => getAdminBasePath() + "/surveyAdmin";
export const getSurveyAdminIndexPath = () => getSurveyAdminBasePath() + "/index";
export const getSurveyAdminDetailsPath = (surveyId) => `${getSurveyAdminBasePath()}/details/${surveyId}`;
export const getSurveyAdminBaseRoute = () => `${getAdminBaseRoute()}/surveyAdmin`;
export const getSurveyAdminIndexRoute = () => `${getSurveyAdminBaseRoute()}/index`;
export const getSurveyAdminDetailsRoute = () => `${getSurveyAdminBaseRoute()}/details/:surveyId`;
export const getSurveyResponseAdminDetailPath = () => getSurveyAdminBasePath() + "/responses/index";
export const getSurveyResponseAdminDetailRoute = () => `${getSurveyAdminBaseRoute()}/responses/index`;
const AdminSurveyRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route, { component: SurveyConfigurator, path: getSurveyAdminIndexRoute() }), _jsx(Route, { component: SurveyDetail, path: getSurveyAdminDetailsRoute() }), _jsx(Route, { component: SurveyResponseAdmin, path: getSurveyResponseAdminDetailRoute() })] }));
};
export default AdminSurveyRoutes;
